import { useMemo, memo } from 'react';
import clsx from 'clsx';

// Imports => Components
import AcMessageCenter from '@components/ac-message-center/ac-message-center';
import AcSubNavigation from '@components/ac-sub-navigation/ac-sub-navigation';

const _CLASSES = {
  MAIN: 'ac-header',
  WHITE: 'ac-header--white',
  ALPHA: 'ac-header--alpha',
  OMEGA: 'ac-header--omega',
};

const AcHeader = ({
  children,
  withMessageCenter = false,
  withNavigation = false,
  theme,
}) => {
  const getMainClassNames = useMemo(() => {
    return clsx(_CLASSES.MAIN, theme && _CLASSES[theme.toUpperCase()]);
  }, [theme]);

  const renderMessageCenter = useMemo(() => {
    return <AcMessageCenter />;
  }, [withMessageCenter]);

  const renderNavigation = useMemo(() => {
    return <AcSubNavigation />;
  }, [withNavigation]);

  return (
    <header className={getMainClassNames} id={'ac-header'}>
      {withMessageCenter && renderMessageCenter}
      {withNavigation && renderNavigation}
      {children}
    </header>
  );
};

// children is static
export default AcHeader;
